import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    display: flex;
    background: #ffffff;
    border: 1px solid #c4c4c4;
    box-shadow: var(--box-shadow);
    border-radius: 8px;

    flex-direction: column;
    padding: var(--padding-base);

    > header {
        display: flex;
        justify-content: space-between;

        > main {
            display: flex;
            justify-content: flex-end;
            flex-direction: column;
            align-items: flex-end;

            > p {
                font-size: 0.7rem;
            }
        }
    }

    > main {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 1rem;

        > * {
            margin-bottom: var(--padding-base);
        }

        > header {
            display: flex;
            flex-direction: column;
            width: 100%;

            > img {
                width: 100%;
                border-radius: var(--border-radius);
                background-color: #eee;
            }
        }
    }
`;

export const DesktopContainer = styled.div`
    width: 100%;
    display: flex;
    background: #ffffff;
    box-shadow: var(--box-shadow);
    border-radius: 8px;

    flex-direction: column;
    padding: var(--padding-base);
    margin-top: 2.5rem;
    > header {
        display: flex;
        justify-content: space-between;

        > main {
            display: flex;
            justify-content: flex-end;
            flex-direction: column;
            align-items: flex-end;

            > p {
                font-size: 0.7rem;
            }
        }
    }

    > main {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 1rem;

        > * {
            margin-bottom: var(--padding-base);
        }

        > header {
            display: flex;
            flex-direction: column;
            width: 100%;

            > img {
                width: 100%;
                border-radius: var(--border-radius);
                background-color: #eee;
            }
        }
    }
`;

export const Title = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    > h1 {
        font-size: 1.3rem;
        color: var(--color-text);
    }

    > aside {
        display: flex;
        flex-direction: row;
    }
`;

export const Description = styled.div`
    width: 100%;

    > div {
        margin-top: 2rem;

        > h3 {
            font-size: 0.9rem;
            color: #979797;
            font-weight: 500;
            margin-top: 0;
            padding-bottom: 0.8rem;
        }

        > p {
            font-size: 0.8rem;
            color: #111;
        }

        &:first-of-type {
            margin-top: 1rem;
        }
    }
`;

export const BlankImage = styled.div`
    width: 100%;
    padding-bottom: 56.25%;
    background-color: #ddd;
    border-radius: var(--border-radius);
`;

export const DescriptionText = styled.div`
    font-size: 0.9rem !important;
    line-height: 1.2rem !important;

    p {
        margin-top: 0.8rem;
    }

    font-size: 0.8rem !important;
    line-height: 1.2rem !important;
    color: #333 !important;
    background-color: transparent !important;
    font-family: 'Myriad Pro', sans-serif !important;

    span {
        font-size: 0.8rem !important;
        color: #333 !important;
        font-family: 'Myriad Pro', sans-serif !important;
        background-color: transparent !important;
        line-height: 1.2rem !important;
    }
`;

export const Certificate = styled.div`
    width: 100%;
    background: #e7f5e6;
    padding: 16px;
    border-radius: 8px;

    > * {
        margin-bottom: 1rem;

        &:last-child {
            margin-bottom: 0;
        }
    }

    h3 {
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 130%;
        text-align: center;
    }

    button {
        display: flex;
        width: auto;
        margin: 0 auto;
        padding: 8px 20px;
        border-radius: 4px;
    }
`;

export const Actions = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 24px;

    > div {
        display: flex;
        align-items: center;
        font-size: 14px;
    }
`;

export const Spacer = styled.div`
    flex-grow: 1;
`;
